/**
 * Form placeholders inside custom code: `<div data-cms-form="contact-us"></div>`
 * (form slug or id). The Region pipeline attaches a `form_embed` child per placeholder
 * and the runtime portals the published form into it.
 */
export const CUSTOM_CODE_FORM_SLOT_ATTR = "data-cms-form";
/** Cosmetic label for the builder canvas placeholder (form name). */
export const CUSTOM_CODE_FORM_SLOT_NAME_ATTR = "data-cms-form-name";
/** Prop on the synthetic `form_embed` child naming the placeholder it fills. */
export const CUSTOM_CODE_FORM_SLOT_PROP = "__customCodeFormSlot";

const FORM_SLOT_RE = /\bdata-cms-form\s*=\s*(["'])([^"']*)\1/gi;
const FORM_REF_PREFIX_RE = /^form:/i;

/** `form:contact-us` / ` Contact-Us ` → `contact-us`. */
export function normalizeCustomCodeFormSlotRef(raw: string): string {
	return raw.trim().replace(FORM_REF_PREFIX_RE, "").trim();
}

/** Unique, normalized form refs (slug or id) referenced by placeholders in `html`. */
export function collectCustomCodeFormSlotRefs(html: string): string[] {
	if (!html.includes(CUSTOM_CODE_FORM_SLOT_ATTR)) {
		return [];
	}
	const refs = new Set<string>();
	for (const match of html.matchAll(FORM_SLOT_RE)) {
		const ref = normalizeCustomCodeFormSlotRef(match[2] ?? "");
		if (ref) {
			refs.add(ref);
		}
	}
	return [...refs];
}

/** Placeholder elements inside `root` that should receive the form `ref`. */
export function findCustomCodeFormSlotTargets(
	root: ParentNode,
	ref: string
): HTMLElement[] {
	const out: HTMLElement[] = [];
	for (const el of root.querySelectorAll<HTMLElement>(
		`[${CUSTOM_CODE_FORM_SLOT_ATTR}]`
	)) {
		const value = normalizeCustomCodeFormSlotRef(
			el.getAttribute(CUSTOM_CODE_FORM_SLOT_ATTR) ?? ""
		);
		if (value === ref) {
			out.push(el);
		}
	}
	return out;
}
